enum DeliveryGraphReport {
  Impressions = 'delivery_graph_impressions',
  Reach = 'delivery_graph_reach',
  Frequency = 'delivery_graph_frequency',
  VCR = 'delivery_graph_vcr',
  LTR = 'delivery_graph_ltr',
  ImpressionsByDay = 'delivery_graph_impressions_by_day',
  DigitalChannel = 'delivery_graph_digital_channel',
  Map = 'delivery_graph_map',
  DeviceType = 'delivery_graph_device_type',
  CampaignName = 'delivery_graph_campaign_name',
  Creative = 'delivery_graph_creative',
  PublisherName = 'delivery_graph_publisher_name',
  DayOfWeek = 'delivery_graph_day_of_week',
  Daypart = 'delivery_graph_daypart',
}

export default DeliveryGraphReport;
